<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {

  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less">
</style>